/**
 * @file debug.js
 * @location src/utils/debug.js
 * @role DEV 한정 로깅 헬퍼 — prod 번들 console.* 노이즈 방지
 *
 * debug(...a)  → import.meta.env.DEV 일 때만 console.log('[debug]', ...a)
 * warn(...a)   → import.meta.env.DEV 일 때만 console.warn('[warn]', ...a)
 *
 * 실제 에러(사용자에 영향 주는 실패, 디버깅 필요한 상황)는 console.error 를 직접 사용.
 * ESLint no-console 룰이 error 만 허용 — 신규 추가는 이 헬퍼나 console.error 로.
 */
const IS_DEV = (() => {
  try { return import.meta.env?.DEV === true; }
  catch { return false; }
})();

export const debug = (...args) => { if (IS_DEV) console.log('[debug]', ...args); };
export const warn  = (...args) => { if (IS_DEV) console.warn('[warn]', ...args); };
